import { saveUuid } from '../appointment_scheduler';
import getFieldValue from '../elements/getFieldValue';
import getForm from '../elements/getForm';
import submitForm from './submitForm';
import trackFormWizardSubmissionEvents from './trackFormWizardSubmissionEvents';

function getUuid(form) {
  return getFieldValue(form, 'uuid') || saveUuid(location.href) || '';
}

function getFormUrl(form) {
  return `https://${process.env.API_HOST}/v1/todos/me/callback/${getUuid(form)}`;
}

function getFormData(form) {
  return {
    reason: 'Contact provided name: ' + getFieldValue(form, 'full_name'),
    number: getFieldValue(form, 'phone_number'),
    time: getFieldValue(form, 'time_to_call')
  };
}

export default async function createCallback(step) {
  const form = getForm(step);
  const formData = getFormData(form);
  const formVersion = getFieldValue(form, 'leadform');
  const url = getFormUrl(form);
  const promise = submitForm(url, { formData: formData, formVersion: formVersion });
  return trackFormWizardSubmissionEvents(promise, step, 'callback_creation');
}
